import { CheckCheck } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { useMarkAllRead } from './use-mark-all-read'
import { useUnreadCount } from './use-unread-count'

/** <Button> form of mark-all-read for page surfaces. shares useMarkAllRead with the palette item */
export function MarkAllReadButton() {
  const unreadQuery = useUnreadCount()
  const unreadCount = unreadQuery.data?.count ?? 0
  const markAll = useMarkAllRead()

  return (
    <Button
      variant='outline'
      size='hero'
      disabled={unreadCount === 0 || markAll.isPending}
      onClick={() => markAll.mutate()}
    >
      <CheckCheck className='size-4' />
      Mark all read
    </Button>
  )
}
